// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RcDad","title":"styles_title__1KyE-"};